export enum EAdminActionOnMultipleSeances {
	validate = "validate",
	unvalidate = "unvalidate"
}
